// import shared css
// import('./scss/shared.scss');

// we need splide on the front-end, and in the wp editor
if (document.querySelector('.js-splide') || document.querySelector('.wp-admin')) {

    import('@splidejs/splide/dist/css/splide-core.min.css');
    import('./scss/components/_carousel.scss');
    import('./scss/components/blocks/_block-content-slider.scss');
    import('./js/components/splide.js');

}

if (document.querySelector('.responsive-nav')) {

    import('./js/components/navigation.js');

}

if (document.querySelector('.js-lightbox')) {

    import('fslightbox');

}

if (document.querySelector('.lozad')) {

    import('./js/common/lozad.js');

}

// we need alpine on the front-end, and in the wp editor
if (document.querySelector('.alpine-js') || document.querySelector('.wp-admin')) {

    import('./js/common/alpine.js');

}

if (document.querySelector('.js-scroll-animate')) {

    import('./js/common/scroll-animation.js');

}

// we need events override scss on front end, and in the wp editor
if (document.querySelector('#em-wrapper') || document.querySelector('.wp-admin')) {
    
    import('./scss/components/_events.scss');
    import('./js/components/events.js');

}

// we need business directory override scss on front end, and in the wp editor
if (document.querySelector('.business-directory') || document.querySelector('.wp-admin')) {
    
    import('./scss/components/_directory.scss');

}

if (document.querySelector('.js-video-hero')) {

    import('./js/components/hero-video.js');

}
